/**
 * 群消息事件
 * Bai.Zhiming
 * 2019-7-31
 */
angular.module("onGroupSystemNotifysModule", []).factory("onGroupSystemNotifys", ["$rootScope",
    function($rootScope) {
        return {
            "1": function(notify) { //onApplyJoinGroupRequestNotify, //申请加群请求（只有管理员会收到）
            },
            "2": function(notify) { //onApplyJoinGroupAcceptNotify, //申请加群被同意（只有申请人能够收到）
            },
            "3": function(notify) { // onApplyJoinGroupRefuseNotify, //申请加群被拒绝（只有申请人能够收到）
            },
            "4": function(notify) { //onKickedGroupNotify, //被管理员踢出群(只有被踢者接收到)
            },
            "5": function(notify) { //onDestoryGroupNotify, //群被解散(全员接收)
               
            },
            "6": function(notify) { //onCreateGroupNotify, //创建群(创建者接收)
            },
            "7": function(notify) { // onInvitedJoinGroupNotify, //邀请加群(被邀请者接收)            
            },
            "8": function(notify) { //onQuitGroupNotify, //主动退群(主动退出者接收)

            },
            "9": function(notify) { //onSetedGroupAdminNotify, //设置管理员(被设置者接收)
            },
            "10": function(notify) { //onCanceledGroupAdminNotify, //取消管理员(被取消者接收)
            },
            "11": function(notify) { //onRevokeGroupNotify, //群已被回收(全员接收)
            },
            "15": function(notify) { //onReadedSyncGroupNotify, //群消息已读同步通知
            },
            "255": function(notify) { //onCustomGroupNotify, //用户自定义通知(默认全员接收)
            },
            "12": function(notify) { //onInvitedJoinGroupNotifyRequest //邀请加群(被邀请者接收,接收者需要同意)
            }
        };
    }
]);